import theme from '@app/ui/theme'
import styled from 'styled-components'
export const Container = styled.div`
  padding: 1rem;
`

export const TeeGrid = styled.div`
  display: flex;
  gap: 1rem;
`
export const ColorInput = styled.input.attrs({ type: 'color' })`
  width: 100%;
  height: 32px;

  border-radius: 0.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease-in-out;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  &::-webkit-color-swatch {
    border: none;
    border-radius: 0.5rem;
  }
  &::-moz-color-swatch {
    border: none;
    border-radius: 0.5rem;
  }
`

export const TeeCard = styled.div<{ $selected?: boolean }>`
  width: 100px;
  box-sizing: border-box;
  border: 1px solid ${({ $selected }) => ($selected ? '#007aff' : '#e2e8f0')};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const TeeCardColor = styled.div`
  padding: 8px 8px 2px 8px;
  width: 90%;
  text-align: center;
`

export const OptionGroupHeading = styled.div`
  margin-bottom: 8px;
  color: #666;
  font-size: ${theme.fontSize[0]}px;
  font-weight: ${theme.fontWeight[3]};
`

export const TeeCardSwatch = styled.button<{ $color: string }>`
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  cursor: pointer;
`

export const TeeCardName = styled.div`
  padding: 2px 8px 8px 8px;
  text-align: center;
  font-size: ${theme.fontSize[1]}px;
`

export const NameInput = styled.input.attrs({ type: 'text' })`
  width: 100%;
  padding: 4px;
  border: 1px solid #e2e8f0;
  font-size: ${theme.fontSize[1]}px;
`

export const TeeContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  align-items: center;
  gap: 0.5rem;
`

export const ButtonText = styled.span`
  color: white;
`

// export const ColorInput = styled.input.attrs({ type: 'color' })`
//   width: 3rem;
//   height: 3rem;
//   border-radius: 0.5rem;
//   cursor: pointer;
//   border: 1px solid #e2e8f0;
//   border-opacity: 0.5;
//   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
//   transition: box-shadow 0.2s ease-in-out;
//
//   &:hover {
//     box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//   }
//
//   /* Remove default color input styles */
//   &::-webkit-color-swatch-wrapper {
//     padding: 0;
//   }
//   &::-webkit-color-swatch {
//     border: none;
//     border-radius: 0.5rem;
//   }
//   &::-moz-color-swatch {
//     border: none;
//     border-radius: 0.5rem;
//   }
// `
